// German Intermediate Vocabulary - 50 unique items
// Each item supports 3 question types: target↔english, definition→target (no romanization)

import { VocabularyItem } from '../../../utils/multipleChoiceLogic';

export const germanIntermediateItems: VocabularyItem[] = [
  // Time & Days (1-10)
  {
    id: 'de-int-001',
    target: 'die Zeit',
    english: 'time',
    definition: 'The ongoing progression of events',
    partOfSpeech: 'noun'
  },
  {
    id: 'de-int-002',
    target: 'heute',
    english: 'today',
    definition: 'The current day',
    partOfSpeech: 'adverb'
  },
  {
    id: 'de-int-003',
    target: 'morgen',
    english: 'tomorrow',
    definition: 'The day after today',
    partOfSpeech: 'adverb'
  },
  {
    id: 'de-int-004',
    target: 'gestern',
    english: 'yesterday',
    definition: 'The day before today',
    partOfSpeech: 'adverb'
  },
  {
    id: 'de-int-005',
    target: 'die Woche',
    english: 'week',
    definition: 'A period of seven days',
    partOfSpeech: 'noun'
  },
  {
    id: 'de-int-006',
    target: 'der Monat',
    english: 'month',
    definition: 'One of twelve divisions of a year',
    partOfSpeech: 'noun'
  },
  {
    id: 'de-int-007',
    target: 'das Jahr',
    english: 'year',
    definition: 'A period of 365 days',
    partOfSpeech: 'noun'
  },
  {
    id: 'de-int-008',
    target: 'Montag',
    english: 'Monday',
    definition: 'The first day of the work week',
    partOfSpeech: 'noun'
  },
  {
    id: 'de-int-009',
    target: 'Freitag',
    english: 'Friday',
    definition: 'The fifth day of the work week',
    partOfSpeech: 'noun'
  },
  {
    id: 'de-int-010',
    target: 'das Wochenende',
    english: 'weekend',
    definition: 'Saturday and Sunday together',
    partOfSpeech: 'noun'
  },

  // Places & Locations (11-20)
  {
    id: 'de-int-011',
    target: 'die Stadt',
    english: 'city',
    definition: 'A large urban area with many buildings',
    partOfSpeech: 'noun'
  },
  {
    id: 'de-int-012',
    target: 'das Land',
    english: 'country / countryside',
    definition: 'A nation or rural area',
    partOfSpeech: 'noun'
  },
  {
    id: 'de-int-013',
    target: 'die Straße',
    english: 'street',
    definition: 'A paved road in a town or city',
    partOfSpeech: 'noun'
  },
  {
    id: 'de-int-014',
    target: 'der Bahnhof',
    english: 'train station',
    definition: 'A place where trains stop for passengers',
    partOfSpeech: 'noun'
  },
  {
    id: 'de-int-015',
    target: 'der Flughafen',
    english: 'airport',
    definition: 'A place where airplanes take off and land',
    partOfSpeech: 'noun'
  },
  {
    id: 'de-int-016',
    target: 'das Restaurant',
    english: 'restaurant',
    definition: 'A place where meals are served to customers',
    partOfSpeech: 'noun'
  },
  {
    id: 'de-int-017',
    target: 'das Hotel',
    english: 'hotel',
    definition: 'A building providing lodging for travelers',
    partOfSpeech: 'noun'
  },
  {
    id: 'de-int-018',
    target: 'die Schule',
    english: 'school',
    definition: 'An institution for education',
    partOfSpeech: 'noun'
  },
  {
    id: 'de-int-019',
    target: 'das Krankenhaus',
    english: 'hospital',
    definition: 'A place where sick people receive medical care',
    partOfSpeech: 'noun'
  },
  {
    id: 'de-int-020',
    target: 'der Supermarkt',
    english: 'supermarket',
    definition: 'A large store selling food and household items',
    partOfSpeech: 'noun'
  },

  // Food & Drinks (21-30)
  {
    id: 'de-int-021',
    target: 'das Frühstück',
    english: 'breakfast',
    definition: 'The first meal of the day',
    partOfSpeech: 'noun'
  },
  {
    id: 'de-int-022',
    target: 'das Mittagessen',
    english: 'lunch',
    definition: 'The midday meal',
    partOfSpeech: 'noun'
  },
  {
    id: 'de-int-023',
    target: 'das Abendessen',
    english: 'dinner',
    definition: 'The evening meal',
    partOfSpeech: 'noun'
  },
  {
    id: 'de-int-024',
    target: 'das Fleisch',
    english: 'meat',
    definition: 'Animal flesh used as food',
    partOfSpeech: 'noun'
  },
  {
    id: 'de-int-025',
    target: 'der Fisch',
    english: 'fish',
    definition: 'An aquatic animal or its flesh as food',
    partOfSpeech: 'noun'
  },
  {
    id: 'de-int-026',
    target: 'das Gemüse',
    english: 'vegetables',
    definition: 'Edible plants or plant parts',
    partOfSpeech: 'noun'
  },
  {
    id: 'de-int-027',
    target: 'das Obst',
    english: 'fruit',
    definition: 'Sweet edible parts of plants',
    partOfSpeech: 'noun'
  },
  {
    id: 'de-int-028',
    target: 'der Käse',
    english: 'cheese',
    definition: 'A dairy product made from milk',
    partOfSpeech: 'noun'
  },
  {
    id: 'de-int-029',
    target: 'das Bier',
    english: 'beer',
    definition: 'An alcoholic beverage made from grain',
    partOfSpeech: 'noun'
  },
  {
    id: 'de-int-030',
    target: 'der Wein',
    english: 'wine',
    definition: 'An alcoholic beverage made from grapes',
    partOfSpeech: 'noun'
  },

  // Adjectives & Descriptions (31-40)
  {
    id: 'de-int-031',
    target: 'groß',
    english: 'big / tall',
    definition: 'Large in size or height',
    partOfSpeech: 'adjective'
  },
  {
    id: 'de-int-032',
    target: 'klein',
    english: 'small / short',
    definition: 'Limited in size or height',
    partOfSpeech: 'adjective'
  },
  {
    id: 'de-int-033',
    target: 'neu',
    english: 'new',
    definition: 'Recently made or discovered',
    partOfSpeech: 'adjective'
  },
  {
    id: 'de-int-034',
    target: 'alt',
    english: 'old',
    definition: 'Having existed for a long time',
    partOfSpeech: 'adjective'
  },
  {
    id: 'de-int-035',
    target: 'schön',
    english: 'beautiful',
    definition: 'Pleasing to look at',
    partOfSpeech: 'adjective'
  },
  {
    id: 'de-int-036',
    target: 'schnell',
    english: 'fast / quick',
    definition: 'Moving at high speed',
    partOfSpeech: 'adjective'
  },
  {
    id: 'de-int-037',
    target: 'langsam',
    english: 'slow',
    definition: 'Moving at low speed',
    partOfSpeech: 'adjective'
  },
  {
    id: 'de-int-038',
    target: 'teuer',
    english: 'expensive',
    definition: 'Costing a lot of money',
    partOfSpeech: 'adjective'
  },
  {
    id: 'de-int-039',
    target: 'billig',
    english: 'cheap',
    definition: 'Low in price',
    partOfSpeech: 'adjective'
  },
  {
    id: 'de-int-040',
    target: 'wichtig',
    english: 'important',
    definition: 'Having great significance',
    partOfSpeech: 'adjective'
  },

  // Common Verbs (41-50)
  {
    id: 'de-int-041',
    target: 'arbeiten',
    english: 'to work',
    definition: 'To do a job or task',
    partOfSpeech: 'verb'
  },
  {
    id: 'de-int-042',
    target: 'spielen',
    english: 'to play',
    definition: 'To engage in games or recreation',
    partOfSpeech: 'verb'
  },
  {
    id: 'de-int-043',
    target: 'lernen',
    english: 'to learn',
    definition: 'To gain knowledge or skills',
    partOfSpeech: 'verb'
  },
  {
    id: 'de-int-044',
    target: 'verstehen',
    english: 'to understand',
    definition: 'To comprehend the meaning of something',
    partOfSpeech: 'verb'
  },
  {
    id: 'de-int-045',
    target: 'kaufen',
    english: 'to buy',
    definition: 'To acquire something by paying money',
    partOfSpeech: 'verb'
  },
  {
    id: 'de-int-046',
    target: 'verkaufen',
    english: 'to sell',
    definition: 'To exchange goods for money',
    partOfSpeech: 'verb'
  },
  {
    id: 'de-int-047',
    target: 'wohnen',
    english: 'to live / to reside',
    definition: 'To have one\'s home in a place',
    partOfSpeech: 'verb'
  },
  {
    id: 'de-int-048',
    target: 'fahren',
    english: 'to drive / to travel',
    definition: 'To operate a vehicle or travel by vehicle',
    partOfSpeech: 'verb'
  },
  {
    id: 'de-int-049',
    target: 'fliegen',
    english: 'to fly',
    definition: 'To travel through the air',
    partOfSpeech: 'verb'
  },
  {
    id: 'de-int-050',
    target: 'schlafen',
    english: 'to sleep',
    definition: 'To rest with eyes closed and mind unconscious',
    partOfSpeech: 'verb'
  }
];
